import React from 'react';
import styled from 'styled-components';
import { Form } from 'formik';
import { getTranslatedString } from 'helpers/i18n';

import { H2, ButtonPrimary } from '@yuhu-inc/yuhui';

import { Switch } from 'antd';

import { media } from 'helpers/MediaHelper';
import { colors } from 'helpers/ColorHelper';

import { StyledFooterText } from './form_fields/shared_styles/footers';

import ReviewQuestionFieldTextType from './components/ServicesUtilities/ReviewQuestionFieldTextType';
import ReviewAnswerFieldTextType from './components/ServicesUtilities/ReviewAnswerFieldTextType';
import ReviewAnswerFieldSwitchType from './components/ServicesUtilities/ReviewAnswerFieldSwitchType';

const StyledForm = styled(Form)`
  width: ${(props) => (props.fieldForms ? '615px' : '330px')};
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: 800px;
  ${media.mobile`
  width: 80%;
  `};
`;

const StyledBodyContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledFieldCardContainer = styled.div`
  width: 100%;
  margin-top: 15px;
  background-color: ${colors.WHITE};
  border-radius: 16px;
  padding: 10px 24px 0px;
`;

const StyledFieldCardContainerDarkGray = styled.div`
  width: 100%;
  margin-top: 10px;
  padding: 24px 24px;
  background-color: ${colors.DIALOG_BACKGROUND};
  border-radius: 16px;
`;

const StyledDivCardContainer = styled.div`
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const StyledButton = styled(ButtonPrimary)`
  min-width: 140px;
  font-size: 18px !important;
`;

const StyledButtonContainerFieldView = styled.div`
  align-self: ${(props) => (props.center ? 'center' : 'flex-start')};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : '30px')};
`;

const ToggleSwitch = styled(Switch)`
  margin-right: 15px;
  border-radius: 100px !important;
`;

export const DocumentTemplateReviewServiceUtilitiesPage = ({
  forward,
  servicesAndUtilities,
  handleCreateTemplate,
  ...rest
}) => {
  const length = servicesAndUtilities?.length;
  const fieldForms = length > 0;

  const handleSubmit = (e) => {
    e.preventDefault();
    handleCreateTemplate();
    forward();
  };

  return (
    <form onSubmit={handleSubmit}>
      <StyledForm fieldForms={fieldForms} {...rest}>
        <H2 contentKey="landlordPortal.documentTemplate.reviewServiceUtilities" centered />
        <StyledBodyContainer>
          {servicesAndUtilities?.map((serviceUtility, questionIndex) => {
            return (
              <StyledFieldCardContainer>
                <h2>{`${getTranslatedString('landlordPortal.documentTemplate.question')} ${
                  questionIndex + 1
                }`}</h2>
                {serviceUtility.answer_type === 'text' ? (
                  <React.Fragment>
                    <ReviewQuestionFieldTextType
                      value={serviceUtility.question_name}
                      header={getTranslatedString('landlordPortal.documentTemplate.defaultValue')}
                    ></ReviewQuestionFieldTextType>
                    {serviceUtility.answers.map((answer) => {
                      return (
                        <StyledDivCardContainer>
                          <ReviewAnswerFieldTextType
                            label={answer.answer_name}
                            value={answer.answer_value}
                          ></ReviewAnswerFieldTextType>

                          {answer.conditional_questions.map((conditionalQuestion) => {
                            return (
                              <StyledFieldCardContainerDarkGray>
                                {conditionalQuestion.type === 'text' ? (
                                  <>
                                    <ReviewQuestionFieldTextType
                                      value={conditionalQuestion.name}
                                      header={getTranslatedString(
                                        'landlordPortal.documentTemplate.defaultValue'
                                      )}
                                    ></ReviewQuestionFieldTextType>
                                    {conditionalQuestion.conditional_answers.map(
                                      (conditional_answer) => {
                                        return (
                                          <ReviewAnswerFieldTextType
                                            label={conditional_answer.name}
                                            value={conditional_answer.value}
                                          ></ReviewAnswerFieldTextType>
                                        );
                                      }
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <h4> {conditionalQuestion.name} </h4>
                                    {conditionalQuestion.conditional_answers.map(
                                      (conditional_answer) => {
                                        return (
                                          <StyledDivCardContainer>
                                            <ToggleSwitch
                                              disabled={true}
                                              checked={conditional_answer.selected}
                                            />
                                            <span> {conditional_answer.name} </span>
                                          </StyledDivCardContainer>
                                        );
                                      }
                                    )}
                                  </>
                                )}
                              </StyledFieldCardContainerDarkGray>
                            );
                          })}
                        </StyledDivCardContainer>
                      );
                    })}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <h4> {serviceUtility.question_name} </h4>
                    {serviceUtility.answers.map((answer) => {
                      return (
                        <StyledDivCardContainer>
                          <ReviewAnswerFieldSwitchType
                            isSelected={answer.selected}
                            label={answer.answer_name}
                          ></ReviewAnswerFieldSwitchType>
                          {answer.conditional_questions.map((conditionalQuestion) => {
                            return (
                              <StyledFieldCardContainerDarkGray>
                                {conditionalQuestion.type === 'text' ? (
                                  <>
                                    <ReviewQuestionFieldTextType
                                      value={conditionalQuestion.name}
                                      header={getTranslatedString(
                                        'landlordPortal.documentTemplate.defaultValue'
                                      )}
                                    ></ReviewQuestionFieldTextType>
                                    {conditionalQuestion.conditional_answers.map(
                                      (conditional_answer) => {
                                        return (
                                          <ReviewAnswerFieldTextType
                                            label={conditional_answer.name}
                                            value={conditional_answer.value}
                                          ></ReviewAnswerFieldTextType>
                                        );
                                      }
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <h4> {conditionalQuestion.name} </h4>
                                    {conditionalQuestion.conditional_answers.map(
                                      (conditional_answer) => {
                                        return (
                                          <StyledDivCardContainer>
                                            <ReviewAnswerFieldSwitchType
                                              isSelected={conditional_answer.selected}
                                              label={conditional_answer.name}
                                            ></ReviewAnswerFieldSwitchType>
                                          </StyledDivCardContainer>
                                        );
                                      }
                                    )}
                                  </>
                                )}
                              </StyledFieldCardContainerDarkGray>
                            );
                          })}
                        </StyledDivCardContainer>
                      );
                    })}
                  </React.Fragment>
                )}
              </StyledFieldCardContainer>
            );
          })}
        </StyledBodyContainer>

        <StyledButtonContainerFieldView center marginTop="177px">
          <StyledButton contentKey="landlordPortal.inspections.next" />
        </StyledButtonContainerFieldView>
        <StyledFooterText>
          {' '}
          {getTranslatedString('landlordPortal.documentTemplate.completedPagesAutoSave')}{' '}
        </StyledFooterText>
      </StyledForm>
    </form>
  );
};
